import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
  /** Hover lift + accent ring (utile pour cards cliquables). */
  interactive?: boolean;
  /** Padding interne. */
  padded?: boolean;
  /**
   * Active le scroll horizontal natif. Par défaut, ON quand `padded=false`
   * (pattern table). Permet à une page mobile de scroller horizontalement
   * dans un tableau large sans casser le layout global.
   */
  scrollX?: boolean;
};

export function Card({
  children,
  className = "",
  interactive = false,
  padded = true,
  scrollX,
}: Props) {
  const isScrollX = scrollX ?? !padded;
  return (
    <div
      className={`rounded-2xl bg-white ring-1 ring-navy-100 shadow-sm ${
        padded ? "p-6" : ""
      } ${isScrollX ? "overflow-x-auto" : ""} ${
        interactive
          ? "transition-all hover:ring-accent-300 hover:shadow-lg hover:shadow-accent-500/10 hover:-translate-y-0.5 cursor-pointer"
          : ""
      } ${className}`.trim()}
    >
      {children}
    </div>
  );
}
